<template>
  <div v-if="!error" class="card my-3">
    <a :href="route" style="color: inherit;">
      <div class="card-body py-3 text-center row justify-content-center align-items-center">
        <div class="col-auto text-center">
          <img :src="small_image_url" class="img-fluid pageThumbnailIcon" />
        </div>
        <div v-if="!loading" class="col-auto ml-3">{{ likes }} likes</div>
        <div v-else class="col-auto ml-3">
          <i class="fa fa-spinner fa-pulse fa-fw"></i> likes
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "PageLikes",

    props: {
        route: {
            type: String,
            required: true
        },
        small_image_url: {
            type: String,
            required: true
        }
  },

  data() {
    return {
      likes: 0,
      loading: true,
      error: false
    };
  },

  created() {
    this.loadLikes();
  },

  methods: {
    loadLikes() {
      this.loading = true;
      var self = this;
      axios
        .get("api/stats/likes")
        .then(function(response) {
          self.loading = false;
          // convert to an array (so we can easily get the length)
          self.likes = response.data;
        })
        .catch(function(error) {
          console.log(error);
          self.error = true;
        });
    }
  }
};
</script>